(function () {
  'use strict';

  angular.module('ringbaPortal').component('overridePayoutSettings', {
    bindings: {
      existingPayoutSettings: '<',
      priority: '<',
      availableTags: '<',
      isDefaultPayout: '<', // hide filter section for default payout
      defaultPayoutObject: '<',
      onUpdate: '&',
      onDismiss: '&',
      onAdd: '&',
      onBulkTagUpload: '&',
      readOnly: '<'
    },
    controller: OverridePayoutSettingsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/override-payout-settings/override-payout-settings.view.html'
  });

  function OverridePayoutSettingsController(
    $timeout
  ) {
    'ngInject';

    const vm = this;

    vm.showFullWidthOptions = {
      showSummaryView: false
    };

    vm.$onInit = onInit;
    vm.updatePayoutSetting = updatePayoutSetting;
    vm.setPayoutSetting = setPayoutSetting;
    vm.closeForm = closeForm;
    vm.showTagFilterSection = showTagFilterSection;
    vm.removeAllFilters = removeAllFilters;

    // vm.payoutSettingsObject is being used for payout-settings-component
    // vm.payoutSettings is being used for route-filter-component
    function onInit() {
      if (vm.existingPayoutSettings) {
        vm.payoutSettingsObject = angular.copy(vm.existingPayoutSettings);
        vm.payoutSettings = vm.payoutSettingsObject;
        vm.addFilter = vm.payoutSettingsObject.criteria && vm.payoutSettingsObject.criteria.length;
        _showSummaryView(vm.addFilter);
      } else {
        vm.payoutSettingsObject = {
          deDupeSetting: {
            secondsFromLastCall: 0
          },
          isRevShare: false,
          priority: vm.priority
        };
        vm.payoutSettings = angular.copy(vm.payoutSettingsObject);
      }
    }

    // This function is used by payout-settings component to maintain the same payout data
    function updatePayoutSetting(event) {
      vm.payoutSettings = event.payoutSettings;
      _onUpdate(vm.payoutSettings);
    }

    // This function is used by route-filter-form component to maintain the same payout data
    function setPayoutSetting(setting) {
      // We need to change the reference of this object to further propagate the changes to vm.payoutSettings to the payout-settings component
      vm.payoutSettingsObject = angular.copy(setting);
      _onUpdate(vm.payoutSettingsObject);
    }

    function closeForm() {
      vm.onDismiss({
        payoutSetting: vm.payoutSettings,
        priority: vm.priority
      });
    }

    function showTagFilterSection() {
      vm.isTagFilterSectionOpen = true;
      vm.showFullWidthOptions.showSummaryView = false;
    }

    function removeAllFilters() {
      vm.isTagFilterSectionOpen = false;
      vm.payoutSettings.criteria = [];
      vm.payoutSettingsObject = angular.copy(vm.payoutSettings);
      _onUpdate(vm.payoutSettingsObject);
    }

    function _showSummaryView(show) {
      vm.isTagFilterSectionOpen = show;
      vm.showFullWidthOptions.showSummaryView = show;
    }

    function _onUpdate(payoutSettings) {
      $timeout(function () {
        vm.onUpdate({ payoutSetting: payoutSettings, invalidInput: vm.overridePayoutSettingForm.$invalid, priority: vm.priority });
      }, 0);
    }

  }
})();
